/**
 * Created with IntelliJ IDEA.
 * created by tendlich & akirilyuk
 *
 * Controller is responsible to display the TicketView & TicketCreateView in the TicketContainer
 */

define(function (require) {
    "use strict";
    var LE = require("app");

    var TicketView = require("connection-views/ticketTab/TicketView");
    var TicketCreateView = require("connection-views/ticketTab/TicketCreateView");
    var CreateTicketStorageModel = require("connection-models/ticketTab/CreateTicketStorageModel");
    var TicketModel = require("connection-models/ticketTab/TicketModel");
    var AttachmentModel = require("connection-models/ticketTab/AttachmentModel");
    var KPsSearchResultsCollection = require("connection-collections/KPsTab/KPsSearchResultsCollection");
    var CommentModel = require("connection-models/ticketTab/CommentModel");
    var CP_CONST = require("connection-const");
    var TicketViewController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        TicketViewController = Marionette.Controller.extend({

            referrerAction: "ticketTest",
            dataInitialized: false,

            initialize: function (options) {
                this.channel = LEConnection.media.channel(LE.mediaCodes.connection.channels.TICKET_VIEW) || {vent: {}};
                this.ticketTabChannel = options.channel || {vent: {}};
                this.contentContainerChannel = options.containerChannel || {vent: {}};
                this.context = options.connectionPanelContextModel || {};
                this.ticketsCollection = options.ticketsCollection || {};
                this._bindEvents();
                this._loadCurrentUserModel();
                LEConnection.logger.debug("TicketViewController.initialize: initialized TicketViewController");
            },

            _bindEvents: function () {
                this.listenTo(this.channel.vent, "TicketViewController::open:chat", this._openChatTab);
                this.listenTo(this.channel.vent, "TicketViewController::createTicket:display", this._displayCreateTicket);
                this.listenTo(this.channel.vent, "TicketViewController::ticket:display", this._displayTicket);
                this.listenTo(this.channel.vent, "TicketViewController::ticket:update", this._initUpdateTicket);
                this.listenTo(this.channel.vent, "TicketViewController::window:close", this._closeView);
                this.listenTo(this.channel.vent, "TicketView::actionMenu:selected", this._onActionMenuSelected);
                this.listenTo(this.channel.vent, "TicketCreateView::trigger:search", this._triggerArticleSearch);
                this.listenTo(this.channel.vent, "TicketCreateView::ticket:save", this._initSaveTicket);
                LEConnection.logger.debug("TicketViewController._bindEvents: successfully binded all events");
            },

            _onStorageModelChanged: function (model) {
                this._updateStorageModel(model);
            },

            _updateStorageModel: function (model) {
                this.storageModel = model;
                LEConnection.parentManager.saveInLocalStorage("createCaseStorageModel", model);
                LEConnection.logger.debug("TicketViewController._updateStorageModel: updated storage model with " + model);
            },

            _onActionMenuSelected: function (itemId) {
                var closeMessage = LE.translator.translate("LEConnection.cases.detailedView.closeCaseMessage")
                    .replace("{reason}", (LE.translator.translate("LEConnection.cases.detailedView.closeCase.reason." + itemId)).toLowerCase());
                var closeComment = new CommentModel({message: closeMessage, unsaved: true});
                closeComment.setCreatedByEmail(this._getUserEmail());
                closeComment.setCreatedByName(this._getUserName());
                this.model.addCustomerComment(closeComment);
                this._initUpdateTicket({status: []});
                LEConnection.vent.trigger("UsageTrackingController:track", {
                    slug: this.model.get("id"),
                    usageToTrack: CP_CONST.USAGE_TO_TRACK.MYCASES.CLOSE_CASE
                });
            },

            _loadCurrentUserModel: function () {
                this.userModel = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getLoggedInUserModel);
                LEConnection.logger.debug("TicketViewController._loadCurrentUserModel: loaded user model from data module " + this.userModel);
            },

            _getAccountId: function () {
                return this.context.getAccountId() || "";
            },

            _getSalesForceId: function () {
                return this.context.getSalesForceId() || "";
            },

            _getAccountName: function () {
                return this.context.getAccountName() || "";
            },

            _getUserEmail: function () {
                if(LE.sessionManager.isLPA()){
                    return LE.sessionManager.getLoginName().toLowerCase().replace("lpa-", "").concat("@liveperson.com");
                }
                return this.userModel.getEmail();
            },

            _getUserName: function () {
                if(LE.sessionManager.isLPA()){
                    return LE.sessionManager.getLoginName();
                }
                return (this.userModel.getDisplayName()) ? this.userModel.getDisplayName() : this.userModel.getNickName();
            },
            _openChatTab: function () {
                this._setSelectedTabToChat();
                this._startChat();
            },

            _startChat: function () {
                LEConnection.vent.trigger("Chat:requested", {
                    group: "LiveEngage2",
                    referrerAction: CP_CONST.REFERER_ACTION.CLICK_TO_CHAT //what s the impact of this? is it ever checked? must it be sth like create case?
                });
                LEConnection.logger.debug("TicketViewController._startChat: started chat from the ticket view");
            },

            _setSelectedTabToChat: function () {
                this.context.set("selectedTab", CP_CONST.TABS.CHAT);
            },

            //ARTICLE SUGGESTION FUNCTIONS
            _triggerArticleSearch: function (searchTerm) {
                var encodedSearchTerm = encodeURIComponent(searchTerm);
                this._triggerArticleFetch(encodedSearchTerm);
            },

            _triggerArticleFetch: function (encodedSearchTerm) {
                var articlesCollection = new KPsSearchResultsCollection();
                var that = this;
                articlesCollection.fetch({
                    lang: this.context.get("locale"),
                    search: encodedSearchTerm,
                    userId: this.context.get("userId"),
                    accountId: this.context.get("accountId"),
                    success: function () {
                        that._displaySearchResults(articlesCollection);
                        LEConnection.logger.debug("TicketViewController._triggerArticleFetch: success fetching article suggestions for create ticket view");
                    },
                    error: function () {
                        that._displaySearchResults(articlesCollection);
                        LEConnection.logger.debug("TicketViewController._triggerArticleFetch: error loading article suggestions for create ticket view");
                    },
                    reset: true
                });
            },

            _displaySearchResults: function (collection) {
                this.channel.vent.trigger("TicketCreateView::display:searchResults", collection);
            },

            // ---- TICKET FUNCTIONS ----
            _addModelToCollection: function (model) {
                this.ticketTabChannel.vent.trigger("TicketTabController::add:ticket", model);
            },

            _refreshView: function () {
                this.ticketView = new TicketView({model: this.model, channel: this.channel});
                this._displayView({view: this.ticketView});
                LEConnection.logger.debug("TicketViewController._refreshView: refreshed view");
            },

            _displayView: function (options) {
                this.contentContainerChannel.trigger("TicketExtendedContainerController::container:displayTicketView", options);
                LEConnection.logger.debug("TicketViewController._displayView: triggered display view");
            },

            _closeView: function () {
                this.ticketTabChannel.vent.trigger("TicketTabController::ticketView:close");
                LEConnection.logger.debug("TicketViewController._closeView: triggered close view");
            },

            _displayTicket: function (_options) {
                var options = _options || {};
                options.channel = this.channel;
                this.model = options.model;
                this.ticketView = new TicketView(options);
                options.view = this.ticketView;
                this._displayView(options);
                LEConnection.logger.debug("TicketViewController._displayTicket: successfully initiated the display ticket call");
            },

            _displayCreateTicket: function (_options) {
                LEConnection.logger.debug("TicketViewController._displayCreateTicket: started creating the TicketCreateView");
                var options = _options || {};
                options.channel = this.channel;
                options.context = this.context;
                this.model = new TicketModel({
                    contactEmail: this._getUserEmail(),
                    contactName: this._getUserName(),
                    siteId: this._getAccountId(),
                    accountName: this._getAccountName(),
                    accountId: this._getSalesForceId()
                });
                options.model = this.model;
                options.storageModel = this._getCreateTicketStorageModel();
                this.ticketView = new TicketCreateView(options);
                options.view = this.ticketView;
                this._displayView(options);
                LEConnection.logger.debug("TicketViewController._displayCreateTicket: successfully initiated and created the createTicketView");
            },


            _initSaveTicket: function (_model) {
                LEConnection.logger.debug("TicketViewController._initSaveTicket: started the initialization of a save call for a new support case");
                this._openLoader();
                var that = this;
                _model.setOrigin("Connection Panel");
                var attachments = _model.getUnsavedAttachments() || [];
                _model.removeUnsavedAttachments();
                _model.save(null, {
                    success: function (model, response) {
                        LEConnection.logger.debug("TicketViewController._initSaveTicket._model.save: initialized TicketViewController");
                        var savedModel = new TicketModel(response);
                        var successMessage = LE.translator.translate("LEConnection.cases.createView.caseCreation.success").replace("{caseNumber}", savedModel.getCaseNumber());
                        that._showSuccessExtended(successMessage, 10000);
                        that.model = savedModel;
                        that._addModelToCollection(savedModel);
                        that._updateStorageModel(new CreateTicketStorageModel());
                        if (attachments.length > 0) {
                            _.each(attachments, function (one) {
                                one.parentId = response.id;//map the right parent id to the attachments ugly, but working
                            });
                            that._initSaveAttachments(attachments);
                        } else {
                            that._closeLoader();
                            that._closeView();
                            that.ticketTabChannel.vent.trigger("TicketTabController::ticket:display", {model: savedModel});
                        }
                    }, error: function () {
                        that._closeLoader();
                        that._showErrorExtended(LE.translator.translate("LEFramework.errors.serverError.1100"));
                        LEConnection.logger.error("TicketViewController._initSaveTicket: failed to create a new case");
                        LEConnection.logger.graph({name: "connection:TicketViewController:couldNotCreateNewCase"});
                    }
                });

            },

            _initUpdateTicket: function (_options) {
                // check if the case needs to be updated, if no dont do anything & errormsg
                this._openLoader();
                var options = _options || {};
                var visibilityHasChanged = !_.isNull(options.visibility) && this.model.getVisibility() != options.visibility;
                var commentExists = !_.isUndefined(options.comment) && !_.isNull(options.comment);
                if (commentExists) {
                    options.comment.setCreatedByEmail(this._getUserEmail());
                    options.comment.setCreatedByName(this._getUserName());
                    this.model.addCustomerComment(options.comment);
                }
                if (visibilityHasChanged) {
                    this.model.setVisibility(options.visibility);
                }
                //check if there are attachments, if yes, handle them first
                var unsavedAttachments = this.model.getUnsavedAttachments();
                if (!_.isNull(unsavedAttachments)) {
                    this._initSaveAttachments(unsavedAttachments, commentExists || visibilityHasChanged);
                } else {
                    if (!commentExists && !visibilityHasChanged) {
                        this._showInfoExtended(LE.translator.translate("LEConnection.cases.detailedView.nothingToSave"));
                        this._closeLoader();
                    } else {
                        this._updateTicket();
                    }
                }
            },

            _updateTicket: function () {
                var that = this;
                var callbacks = {
                    success: function (model, response) {
                        that.model.set(response);
                        that._showSuccessExtended(LE.translator.translate("LEConnection.cases.notification.success"));
                        that.ticketView.closeLoader();
                    },
                    error: function (model, response) {
                        that.ticketView.closeLoader();
                        if (response && response.status === 403) {
                            that._showErrorExtended(LE.translator.translate("LEFramework.errors.serverError.1201"));
                            LEConnection.logger.error("TicketViewController._updateTicket: failed to update an existing case due to auth error");
                            LEConnection.logger.graph({name: "connection:TicketViewController:couldNotUpdateCaseDueToAuthError"});
                        } else {
                            that._showErrorExtended(LE.translator.translate("LEFramework.errors.serverError.1100"));
                            LEConnection.logger.error("TicketViewController._updateTicket: failed to update an existing case due to server error ");
                            LEConnection.logger.graph({name: "connection:TicketViewController:couldNotUpdateCaseDueToServerError"});
                        }
                        that._reloadTicketModel();
                    }
                };
                this.model.save(null, callbacks);
            },

            _reloadTicketModel: function () {
                this._openLoader();
                var that = this;
                this.model.fetch({
                    success: _.bind(function (model, response) {
                        that.model.set(response);
                        this._closeLoader();
                    }, this),
                    error: _.bind(function () {
                        this._closeLoader();
                        LEConnection.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
                        LEConnection.logger.error("TicketViewController._reloadTicketModel:failed to reload case model from server");
                        LEConnection.logger.graph({name: "connection:TicketViewController:couldNotReloadCaseModelFromServer"});
                    }, this)
                });
            },


            // ---- ATTACHMENTS FUNCTIONS ----



            _initSaveAttachments: function (unsavedAttachments, updateCall) {
                LEConnection.logger.debug("TicketViewController._initSaveAttachments: initialize the save atachments call started");
                //only show Notification if uploading file
                this._showInfoExtended(LE.translator.translate("LEConnection.cases.attachmentUpload.info.start"));
                //init the save options and needed values
                var attachmentsToSave = unsavedAttachments || [];
                var succeedSave = [];
                var statusMessages = [];
                var that = this;
                var timeout = CP_CONST.ATTACHMENTS.UPLOAD_TIMEOUT || 120000;
                //first call on save
                var saveOptions = {
                    toSave: attachmentsToSave,
                    saved: succeedSave,
                    status: statusMessages,
                    timeout: timeout,
                    iframe: true,
                    updateCall: updateCall
                };
                new AttachmentModel(attachmentsToSave.pop()).save(null, that._generateSaveAttachmentsCallback(saveOptions));
            },

            _generateSaveAttachmentsCallback: function (saveOptions) {
                LEConnection.logger.debug("TicketViewController._generateSaveAttachmentsCallback: generate save attachments callback");
                var that = this;
                return {
                    success: function (model, response, options) {
                        LEConnection.logger.debug("TicketViewController._generateSaveAttachmentsCallback.success: attachment upload was success");
                        saveOptions.status.push({
                            code: "SUCCESS",
                            message: "Attachment" + model.get("filename") + " was saved."
                        });
                        saveOptions.saved.push(new AttachmentModel(response));
                        that._showSuccessExtended(LE.translator.translate("LEConnection.cases.attachmentUpload.upload.success").replace("{filename}", model.get("filename")));
                        if (saveOptions.toSave.length > 0) {
                            new AttachmentModel(saveOptions.toSave.pop()).save(null, that._generateSaveAttachmentsCallback(saveOptions));
                        } else {
                            that._onAttachmentsSaveFinish(saveOptions);
                        }
                    },
                    error: function (model, response, options) {
                        LEConnection.logger.error("TicketViewController._generateSaveAttachmentsCallback.error: attachment upload was error");
                        saveOptions.status.push({
                            code: "ERROR",
                            message: "Could not save " + model.get("filename"),
                            response: response
                        });
                        that._showErrorExtended(LE.translator.translate("LEConnection.cases.attachmentUpload.upload.error").replace("{filename}", model.get("filename")));
                        if (saveOptions.toSave.length > 0) {
                            new AttachmentModel(saveOptions.toSave.pop()).save(null, that._generateSaveAttachmentsCallback(saveOptions));
                        } else {
                            that._onAttachmentsSaveFinish(saveOptions);
                        }
                    },
                    timeout: saveOptions.timeout,
                    iframe: saveOptions.iframe
                };
            },

            _onAttachmentsSaveFinish: function (saveOptions) {
                LEConnection.logger.debug("TicketViewController._onAttachmentSaveFinish: finished saving attachments" + saveOptions);
                var that = this;
                this.model.removeUnsavedAttachments();
                _.each(saveOptions.saved, function (value) {
                    that.model.addAttachment(value);
                });
                if (saveOptions.updateCall === true) {
                    this._updateTicket(saveOptions);
                } else if (_.isUndefined(saveOptions.updateCall)) {
                    var successMessage = LE.translator.translate("LEConnection.cases.createView.caseCreation.success").replace("{caseNumber}", this.model.getCaseNumber());
                    this._showSuccessExtended(successMessage, 10000);
                    this.ticketTabChannel.vent.trigger("TicketTabController::ticket:display", {model: this.model});
                } else {
                    this._closeLoader();
                }
            },

            _getCreateTicketStorageModel: function () {
                if (this.storageModel) {
                    this.storageModel.set(LEConnection.parentManager.getFromLocalStorage("createCaseStorageModel"));
                } else {
                    this.storageModel = new CreateTicketStorageModel();
                    LEConnection.parentManager.saveInLocalStorage("createCaseStorageModel", this.storageModel);
                }
                this.listenTo(this.storageModel, "change", this._onStorageModelChanged);
                return this.storageModel;
            },

            _showErrorExtended: function (message) {
                if (this.infoNotifier) {
                    this.infoNotifier.close();
                }
                if (this.successNotifier) {
                    this.successNotifier.close();
                }
                LEConnection.notifier.showErrorExtended(message);
            },

            _showInfoExtended: function (message) {
                if (this.successNotifier) {
                    this.successNotifier.close();
                }
                this.infoNotifier = LEConnection.notifier.showInfoExtended(message);
            },

            _showSuccessExtended: function (message, timeToShow) {
                if (this.infoNotifier) {
                    this.infoNotifier.close();
                }
                this.successNotifier = LEConnection.notifier.showSuccessExtended(message, timeToShow);
            },

            // ---- LOADER ----
            _openLoader: function () {
                this.ticketView.setLoader();
            },

            _closeLoader: function () {
                this.ticketView.closeLoader();
            }
        });
    });
    return TicketViewController;
});


